export { default } from './CategoryDetail';
